/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { useState } from 'react';

import { GuardedButton } from '@/components/GuardedButton';
import { PageHeader } from '@/components/PageHeader';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { NewSubtenantModal } from '@/pages/Subtenants/NewSubtenantModal';
import { Container } from '@/primitives/Container';
import './SubtenantsHeader.css';

const { useBreakpoint } = Grid;

export function SubtenantsHeader() {
  const { t } = useMimicTranslation('subtenants');
  const screens = useBreakpoint();

  const [newSubtenantOpen, setNewSubtenantOpen] = useState<boolean>(false);

  const onCancelModal = () => {
    setNewSubtenantOpen(false);
  };

  const buttonHeight = screens.sm ? undefined : '45px';
  const buttonWidth = screens.sm ? undefined : '196px';

  return (
    <div className="subtenants-header">
      <PageHeader title={t('title')} text={t('subtitle')} level={2} />
      <Container horizontal gap="sm">
        <GuardedButton
          requiredRole="editor"
          type="primary"
          dataTestId="new-subtenant"
          onClick={() => setNewSubtenantOpen(!newSubtenantOpen)}
          style={{
            height: buttonHeight,
            width: buttonWidth,
          }}
          className="new-subtenant-button"
        >
          <PlusOutlined /> {t('newSubtenant')}
        </GuardedButton>
      </Container>
      <NewSubtenantModal newSubtenantOpen={newSubtenantOpen} onCancelModal={onCancelModal} />
    </div>
  );
}
